import { IPE_LopTinChiCreateRequest } from "../../../model/request/lop-tin-chi/IPE_LopTinChiCreateRequest";
import { IPE_LopTinChiCreateMultipleRequest } from "../../../model/request/lop-tin-chi/IPE_LopTinChiCreateMultipleRequest";
import { IPE_LopTinChiUpdateRequest } from "../../../model/request/lop-tin-chi/IPE_LopTinChiUpdateRequest";
import { ILopTinChiUpdateIdLopsRequest } from "../../../model/request/lop-tin-chi/ILopTinChiUpdateIdLopsRequest";
import { IPhamViNhomLopUpdateRequest } from "../../../model/request/lop-tin-chi/IPhamViNhomLopUpdateRequest";
import { ISuKienSelectRequest } from "../../../model/request/tkb/ISuKienSelectRequest";
import { ISuKienUpdateRequest } from "../../../model/request/tkb/ISuKienUpdateRequest";
import { IXepTKBLopTCRespone } from "../../../model/respone/lop-tin-chi/IXepTKBLopTCRespone";
import { ILopTinChiViewModel } from "../../../model/respone/lop-tin-chi/ILopTinChiViewModel";
import { ISuKienViewModel } from "../../../model/respone/lop-tin-chi/ISuKienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const ePEActionsObj = {
  CHANGE_FILTER: {} as ISuKienSelectRequest,

  LOAD_LIST_START: {} as ISuKienSelectRequest,
  LOAD_LIST_SUCCESS: {} as IXepTKBLopTCRespone,
  LOAD_LIST_ERRR: "",

  // Modal thêm/sửa: payload undefined -> thêm; có lớp -> sửa.
  OPEN_MODAL: undefined as ILopTinChiViewModel | undefined,
  CLOSE_MODAL: undefined as undefined,

  CREATE_START: {} as IPE_LopTinChiCreateRequest,
  CREATE_MULTIPLE_START: {} as IPE_LopTinChiCreateMultipleRequest,
  CREATE_SUCCESS: 0 as number,
  CREATE_ERRR: "",

  UPDATE_START: {} as IPE_LopTinChiUpdateRequest,
  UPDATE_SUCCESS: 0 as number,
  UPDATE_ERRR: "",

  DELETE_START: 0 as number,
  DELETE_MULTIPLE_START: [] as number[],
  DELETE_SUCCESS: 0 as number,
  DELETE_ERRR: "",

  UPDATE_IDLOPS_START: {} as ILopTinChiUpdateIdLopsRequest,
  UPDATE_IDLOPS_SUCCESS: 0 as number,
  UPDATE_IDLOPS_ERRR: "",

  // Phạm vi nhóm lớp (PLAN_PhamViDangKyLop_TC, id_lop=0) — thêm/xóa từng phần cho nhiều lớp tín chỉ.
  UPDATE_PHAMVI_NHOMLOP_START: {} as IPhamViNhomLopUpdateRequest,
  UPDATE_PHAMVI_NHOMLOP_SUCCESS: 0 as number,
  UPDATE_PHAMVI_NHOMLOP_ERRR: "",

  UPDATE_SUKIEN_START: {} as ISuKienUpdateRequest,
  UPDATE_SUKIEN_SUCCESS: [] as ISuKienViewModel[],
  UPDATE_SUKIEN_TRUNG: {} as { request: ISuKienUpdateRequest; message: string },
  UPDATE_SUKIEN_ERRR: "",
};
export const ePEActionIds = generateActionTypeIds(ePEActionsObj, "PE");
export type IPEActionTypes = IGenericActionType<typeof ePEActionsObj, "PE">;
